module.exports = __webpack_public_path__ + "media/iphone.c2b57268.webm";